import { IAppState } from "../../store";

export function getCustomer(state: IAppState) {
  return state.customerReducer.customer;
}
